"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _translate = _interopRequireDefault(require("../translate"));
var _hawaComponents = require("hawa-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
var ProductSubTypeSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(ProductSubTypeSelector, _React$Component);
  function ProductSubTypeSelector(props) {
    var _this;
    _classCallCheck(this, ProductSubTypeSelector);
    _this = _possibleConstructorReturn(this, (ProductSubTypeSelector.__proto__ || Object.getPrototypeOf(ProductSubTypeSelector)).call(this, props));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.triggerClick = _this.triggerClick.bind(_assertThisInitialized(_this));
    _this.state = {
      isOpenWithout: false,
      isOpenWith: false
    };
    return _this;
  }
  _createClass(ProductSubTypeSelector, [{
    key: "triggerClick",
    value: function triggerClick(e, type) {
      e.preventDefault();
      e.stopPropagation();
      if (type === 'without') {
        this.setState({
          isOpenWithout: true
        });
      } else if (type === 'with') {
        this.setState({
          isOpenWith: true
        });
      }
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        isOpenWithout: false,
        isOpenWith: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var t = this.props.t;
      var svgPath = '27.8,25 49.9,2.9 47.1,0.1 25,22.1 2.9,0.1 0,' + '2.9 22.1,25 0,47.1 2.9,50 25,27.9 47.1,50 49.9,47.1';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'selector-div',
        onClick: this.props.onClick
      }, /*#__PURE__*/_react.default.createElement(_hawaComponents.Modal, {
        id: 'product-type-' + this.props.productData.title + '-without',
        isOpen: this.state.isOpenWithout,
        escClose: true,
        closeHandler: this.closeModal
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'modal-inner'
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: 'close-wrapper'
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: 'close',
        onClick: this.closeModal
      }, /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 50 50"
      }, /*#__PURE__*/_react.default.createElement("polygon", {
        fill: "#fff",
        points: svgPath
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: 'image-wrapper'
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: t(this.props.description.without.altText),
        className: 'full-img',
        src: this.props.description.without.basePath + '.jpg'
      }))))), /*#__PURE__*/_react.default.createElement(_hawaComponents.Modal, {
        id: 'product-type-' + this.props.productData.title + '-with',
        isOpen: this.state.isOpenWith,
        escClose: true,
        closeHandler: this.closeModal
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'modal-inner'
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: 'close-wrapper'
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: 'close',
        onClick: this.closeModal
      }, /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 50 50"
      }, /*#__PURE__*/_react.default.createElement("polygon", {
        fill: "#fff",
        points: svgPath
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: 'image-wrapper'
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: t(this.props.description.with.altText),
        className: 'full-img',
        src: this.props.description.with.basePath + '.jpg'
      }))))), /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.rootPage
      }, t('back')), /*#__PURE__*/_react.default.createElement("h1", null, t(this.props.productData.label)), /*#__PURE__*/_react.default.createElement("p", {
        className: 'f-weight-bold'
      }, t('Please choose product')), /*#__PURE__*/_react.default.createElement("p", null, t(this.props.productData.text)), /*#__PURE__*/_react.default.createElement("h2", {
        className: 'd-inline'
      }, t(this.props.description.without.label)), /*#__PURE__*/_react.default.createElement("div", {
        className: 'modal-trigger d-inline',
        onClick: function onClick(e) {
          _this2.triggerClick(e, 'without');
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 16 16",
        className: 'search-box'
      }, /*#__PURE__*/_react.default.createElement("circle", {
        fill: "none",
        stroke: "#fff",
        strokeMiterlimit: "10",
        cx: "6.98",
        cy: "6.98",
        r: "2.74"
      }), /*#__PURE__*/_react.default.createElement("line", {
        fill: "none",
        stroke: "#fff",
        strokeMiterlimit: "10",
        x1: "8.84",
        y1: "8.98",
        x2: "11.93",
        y2: "12.07"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x mb-100 mt-20'
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.productData.selector[0].link,
        className: 'cell large-4 medium-6 small-8 selector-box'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x w-100'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'cell medium-10 small-10'
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: 'selector-btn-text d-inline',
        dangerouslySetInnerHTML: {
          __html: t(this.props.productData.without.text)
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'cell medium-2 small-2 arrow-div'
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: 'arrow-right',
        src: '/static/assets/images/arrow-right.svg',
        alt: 'Mit Schliessdämpfung planen'
      }))))), /*#__PURE__*/_react.default.createElement("h2", {
        className: 'd-inline'
      }, t(this.props.description.with.label)), /*#__PURE__*/_react.default.createElement("div", {
        className: 'modal-trigger d-inline',
        onClick: function onClick(e) {
          _this2.triggerClick(e, 'with');
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 16 16",
        className: 'search-box'
      }, /*#__PURE__*/_react.default.createElement("circle", {
        fill: "none",
        stroke: "#fff",
        strokeMiterlimit: "10",
        cx: "6.98",
        cy: "6.98",
        r: "2.74"
      }), /*#__PURE__*/_react.default.createElement("line", {
        fill: "none",
        stroke: "#fff",
        strokeMiterlimit: "10",
        x1: "8.84",
        y1: "8.98",
        x2: "11.93",
        y2: "12.07"
      }))), this.props.productData.toggle ? /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x mb-100'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x w-100'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'cell medium-10 small-10'
      }, /*#__PURE__*/_react.default.createElement("p", null, t(this.props.description.with.description)), /*#__PURE__*/_react.default.createElement("p", {
        className: 'f-weight-bold'
      }, t(this.props.description.toggleLabel)), /*#__PURE__*/_react.default.createElement("a", {
        href: t(this.props.description.download),
        className: 'my-0'
      }, t('download'))))) : /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x mb-100 mt-20'
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.productData.selector[1].link,
        className: 'cell large-4 medium-6 small-8 selector-box'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x w-100'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'cell medium-10 small-10'
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: 'selector-btn-text d-inline',
        dangerouslySetInnerHTML: {
          __html: t(this.props.productData.with.text)
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'cell medium-2 small-2 arrow-div'
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: 'arrow-right',
        src: '/static/assets/images/arrow-right.svg',
        alt: 'Mit Schliessdämpfung planen'
      }))))));
    }
  }]);
  return ProductSubTypeSelector;
}(_react.default.Component);
ProductSubTypeSelector.propTypes = {
  t: _propTypes.default.func.isRequired,
  lng: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.object,
  productData: _propTypes.default.object,
  rootPage: _propTypes.default.string,
  match: _propTypes.default.object,
  location: _propTypes.default.object,
  onClick: _propTypes.default.func
};
var _default = (0, _translate.default)(ProductSubTypeSelector);
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/product-subtype-selector/index.js
// module id = 462
// module chunks = 0